import { Auth } from 'aws-amplify'
import { getProgramData, showBuildingPicker } from '../redux/app/actions'
import { StorageService } from './StorageService'
import history from '../History'

export const setCurrentBuilding = (data) => {
    // Store the current building data with a flag indicating it was explicitly selected
    const enhancedData = {
        ...data,
        __wasExplicitlySelected: true
    };
    StorageService.set('currentBuilding', enhancedData)

    Auth.currentAuthenticatedUser().then((user) => {
        // Get data for the selected building
        getProgramData(data, user)
        // Hide the building picker
        showBuildingPicker(false)

        // Get user info from Cognito to check roles
        const userInfo = user.signInUserSession.idToken.payload
        const roles = userInfo['cognito:groups'] || []

        // Check for admin roles
        const isPropertyAdmin = roles.includes('PROPERTY_ADMIN')
        const isBuildingAdmin = roles.includes('BUILDING_ADMIN')
        const isTenantAdmin = roles.includes('TENANT_ADMIN')
        const isSuperAdmin = roles.includes('SUPER_ADMIN')
        const isAdmin = isPropertyAdmin || isBuildingAdmin || isTenantAdmin || isSuperAdmin

        // This function is called when actively switching buildings, so we should
        // redirect the user to the appropriate admin page for the selected building
        if (isSuperAdmin) {
            // Super admin should always go to dashboard
            history.push('/dashboard')
        } else if (isPropertyAdmin) {
            history.push(`/admin/properties/${data.property_pk || data.propertyId}`)
        } else if (isBuildingAdmin) {
            history.push(`/admin/buildings/${data.pk || data.buildingId}`)
        } else if (isTenantAdmin) {
            history.push(`/admin/tenants/${data.tenant_pk || data.tenantId}`)
        } else {
            // For non-admin users (occupants)
            // Note: We don't have direct access to modules here, so we rely on the
            // existing Redux action to handle the routing in getProgramData
            // The redirect will be handled there based on module settings
        }
    })
}
